<template>
  <div>
    <template v-if="isAudioSupported">
    <b-row>
      <b-col>
        <p>{{ recordingMsg }}</p>
      </b-col>
      <b-cols>
        <b-link
            id="startRecording"
            class="add-crew-btn"
            @click="handleStartRecordingClick"
        >
          {{ showRecord ? recordMsgTxt :''}}
        </b-link>
        <b-link
            v-if="showCanEndRecording"
            id="stopRecording"
            @click="handleStopRecordingClick"
        >
          Done
        </b-link>
        <b-row v-if="showLikeAndSave">
          <p>Like it?&nbsp;</p>
          <b-link
              @click="handleSaveAudio"
          > Yes!
          </b-link> |
          <b-link
              v-if="showLikeAndSave"
              @click="">
             Re-record
          </b-link>
        </b-row>
      </b-cols>
    </b-row>
    <b-row>
      <b-col cols="8">
        <audio src=""
               id="audioElement"
               controls
        />
      </b-col>
      <b-col cols="4">
      </b-col>
    </b-row>
    </template>
    <div v-else>
      <h6>Audio is not supported on this device</h6>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "ResourceBlocks_AudioRecorder",
  components: {},
  props: {
    validityArray: {
      type: Boolean,
      default: ()=> [true]
    },
    storagePath: {
      type: String,
      default: ''
    },
    recordMsgTxt:{
      type: String,
      default:'Record a message'
    }
  },
  created() {},
  mounted() {
    this.handlePrepareRecorder();
  },
  computed: {
    showRecord(){
      return !this.recordingAudio && this.isAudioSupported && !this.blob
      && this.validityArray.every(v => v === true)
    },
    showCanEndRecording(){
      return this.recordingAudio;
    },
    showLikeAndSave(){
      return !this.recordingAudio && this.blob && !this.isEmittedForSave;
    }
  },
  methods: {
    initFunction() {// Display recording
      this.recordingMsg = "Recording...";
      this.recordingAudio = true;
      this.startusingBrowserMicrophone(true);
    },
    handlePrepareRecorder(){
      document
          .getElementById("startRecording")
          .addEventListener("click", this.initFunction);
    },
    async getUserMedia(constraints) {
      if (window.navigator.mediaDevices) {
        return window.navigator.mediaDevices.getUserMedia(constraints);
      }
      let legacyApi =
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia;

      if (legacyApi) {
        this.isAudioSupported = true;
        return new Promise(function (resolve, reject) {
          legacyApi.bind(window.navigator)(constraints, resolve, reject);
        });

      } else {
        this.isAudioSupported = false;
      }
    },
    handlerFunction(stream) {
      this.rec = new MediaRecorder(stream);
      this.rec.start();
      this.rec.ondataavailable = (e) => {
        this.audioChunks.push(e.data);
        if (this.rec.state == "inactive") {

          this.setRecordingStatusStopped();
          this.blob = new Blob(this.audioChunks, { type: "audio/mp3" });
          console.log(this.blob);
          document.getElementById("audioElement").src = URL.createObjectURL(this.blob);
        }
      };
    },
    startusingBrowserMicrophone(boolean) {
      this.getUserMedia({ audio: boolean })
          .then((stream) => {
            this.handlerFunction(stream);
          }).catch((e)=>{
        console.error(e);
      });
    },
    handleStartRecordingClick() {
    },
    handleStopRecordingClick() {
      this.rec.stop();
    },
    setRecordingStatusStopped(){
      this.recordingAudio = false;
      this.recordingMsg = "Click play to listen";
    },
    handleSaveAudio() {
      this.audioInfo._created_at= Date.now();

      let file = new File([this.blob], 'memories.mp3');
      //@ToDoget filename from photo
      let fileName= 'memories';
      let storagRef= this.getStorageReference(`app_photoalbum_audios`, fileName);

      this.uploadAudioToStorage(file, storagRef).then((response)=>{
        this.audioInfo.audioURL = response;
        this.isEmittedForSave = true;
        this.$emit('audio-recorded-info', this.audioInfo);
      }).catch((e)=>{
        console.log(e);
      });
    },
    getStorageReference(storagePath, fileName) {
      let result = "";
      var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 15; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
      }
      const timeStamp = new Date().valueOf();

      var storageRef = firebase
          .storage()
          .ref(`${storagePath}/${fileName}_${result}_${timeStamp}`);
      return storageRef;
    },
    uploadAudioToStorage(blob, storageRef) {
      return new Promise((res, rej) => {
        var metadata = {
          contentType: "audio/mp3"
        };
        var uploadTask = storageRef.put(blob,metadata);
        uploadTask.on(
            "state_changed",
            snapshot => {
              var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              //console.log(`Upload is ${progress}% done`);
              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                  //console.log("Upload is paused");
                  break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                  //console.log("Upload is running");
                  break;
              }
            },
            error => {
              rej(error);
            },
            () => {
              uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(downloadURL => {
                    res(downloadURL);
                  })
                  .catch(error => {
                    rej(error);
                    //console.log("Error uploading image: ", error);
                  });
            }
        );
      });
    },
  },
  data() {
    return {
      recordingAudio: false,
      isAudioSupported: true,
      isEmittedForSave: false,
      blob: null,
      rec: null,
      isRecording: null,
      audioChunks: [],
      audioInfo:{  //Collected by Ponyengine- maybe can be used in places
        _created_at: null,
        audioURL: null,
        record_count: 0
      },
      recordingMsg:"Click start to Record"
    };
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
button {
  padding: 7px 20px;
  cursor: pointer;
}
</style>